import { render, staticRenderFns } from "./import-export-dialog.vue?vue&type=template&id=fefc9264&scoped=true"
import script from "./import-export-dialog.vue?vue&type=script&lang=js"
export * from "./import-export-dialog.vue?vue&type=script&lang=js"
import style0 from "./import-export-dialog.vue?vue&type=style&index=0&id=fefc9264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc9264",
  null
  
)

export default component.exports